module.exports = __webpack_public_path__ + "img/japan-respiratory-diseases-female.105a900a.png";